// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__kK4JF","rotation":"styles_rotation___DNpS"};